import React from 'react';
import styled from 'styled-components';
import { Book } from './Book';
import { Link } from 'react-router-dom';

interface BookData {
  book_id: number;
  book_title: string;
  author_name: string;
  book_price: string;
  book_cover_path: string;
  book_quantity: number;
}

interface BooksGridProps {
  books: BookData[];
}

const BooksGridContainer = styled.div`
  width: 100%;  
  max-width: 790px;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(214px, 1fr));
  justify-items: center;
  grid-auto-rows: 449px;
  gap: 25px 20px;
  margin: 0 auto;
`;

const BookLink = styled(Link)`
  text-decoration: none;
  color: inherit;
  display: inline-block;
  width: fit-content;
`;

const BooksGrid: React.FC<BooksGridProps> = ({ books }) => {
  return (
    <BooksGridContainer>
      {books.map((book) => (
        <BookLink to={`/book/${book.book_id}`} key={book.book_id}>
          <Book
            title={book.book_title}
            author={book.author_name}
            price={`₴${book.book_price}`}
            image={book.book_cover_path}
            inStock={true}
          />
        </BookLink>
      ))}
    </BooksGridContainer>
  );
};

export default BooksGrid;